module.exports = "/static/assets/f2457825850317e66ef2128504613c30.svg";